export type PlantCareIssueConfidence = 'likely' | 'possible' | 'worth-checking';

export interface PlantCareIssue {
  id: string;
  name: string;
  affectedPlants: string[];
  symptomTags: string[];
  shortDescription: string;
  whatToCheck: string;
  firstAction: string;
  whenNotToAct: string;
  relatedRemedyIds: string[];
  detailGuidance?: string;
  confidence?: PlantCareIssueConfidence;
}

export const PLANT_CARE_ISSUES: PlantCareIssue[] = [
  {
    id: 'blueberry-low-soil-acidity',
    name: 'Soil may not be acidic enough',
    affectedPlants: ['blueberry'],
    symptomTags: ['slow-growth', 'stunted-growth', 'yellowing-leaves', 'poor-growth'],
    shortDescription: 'Blueberries need acidic soil. If soil pH is too high, they struggle to take up nutrients and may grow slowly.',
    whatToCheck: 'Test soil pH before treating. Blueberries generally prefer acidic soil.',
    firstAction: 'If pH is too high, amend with elemental sulfur or a labeled soil acidifier.',
    whenNotToAct: 'Do not add sulfur blindly if soil pH is already in range or if the plant is suffering from wet roots.',
    relatedRemedyIds: ['elemental-sulfur'],
    detailGuidance: 'Coffee grounds and pine needles are often recommended, but they usually do not meaningfully acidify garden soil. Use a soil test and elemental sulfur if acidification is needed.',
    confidence: 'likely',
  },
];

export function getPlantCareIssueById(id: string): PlantCareIssue | undefined {
  return PLANT_CARE_ISSUES.find(issue => issue.id === id);
}
